import { render, staticRenderFns } from "./TheApp.vue?vue&type=template&id=bd86460e"
import script from "./TheApp.vue?vue&type=script&lang=ts"
export * from "./TheApp.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TheApp.vue?vue&type=style&index=0&id=bd86460e&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports